__turbopack_context__.v({
  "icon": "ServiceRequestIcons-module-scss-module__uWLGUq__icon",
});
